export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const DISMISS_MESSAGE = "DISMISS_MESSAGE";
export const REMOVE_DEVICE_EXPIRY = "REMOVE_DEVICE_EXPIRY";
export const RESET_PRODA_INFO = "RESET_PRODA_INFO";
export const REMOVE_CERTIFICATE_EXPIRY_WARNING =
  "REMOVE_CERTIFICATE_EXPIRY_WARNING";
